import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  merchantStoreCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import type { MerchantStoreDto } from "@/features/merchant/api/dto";

/** Crée un point de vente (`POST /MerchantStores/add`). */
export const useCreateMerchantStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["merchant", "merchant-stores", "create"],
    mutationFn: (body: MerchantStoreDto) =>
      mutateData({
        url: merchantEndpoints.merchantStores.add,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<MerchantStoreDto>,
    onSuccess: (_data, variables) => {
      return invalidateAfterMutation(
        queryClient,
        merchantStoreCacheKeys(variables.merchantId),
        { resetListPage: true }
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useCreateMerchantStore failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "merchant" }
      );
    },
  });
};
